import React from 'react';
import memoize from 'memoize-one';
import { ApprovementStatus, ApproveRejectActions } from '../../../components';

const permissionAdminDaysColumns = memoize(clickHandler => [
  {
    name: 'FECHA DE SOLICITUD',
    selector: 'created_at',
    sortable: true,
    grow: 2,
    center: true
  },
  {
    name: 'FECHA INICIO',
    selector: 'start_date',
    sortable: true,
    grow: 2,
    center: true
  },
  {
    name: 'FECHA TÉRMINO',
    selector: 'end_date',
    cell: item => (item.end_date ? item.end_date : `${item.start_time} - ${item.end_time}`),
    sortable: true,
    grow: 2,
    center: true
  },
  {
    name: 'TIPO DE PERMISO',
    selector: 'permission_type',
    cell: item => item.translated_permission_type || item.translated_vacation_type,
    sortable: true,
    grow: 3,
    center: true
  },
  {
    name: 'ESTADO',
    selector: 'status',
    cell: item => <ApprovementStatus status={item.status} onClick={() => clickHandler(item, 'show')} />,
    sortable: true,
    grow: 1,
    center: true
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <ApproveRejectActions
        item={item}
        resource="Permission"
        clickHandler={clickHandler}
        approveText={item.request_reviewer_signature ? 'Firmar' : 'Aprobar'}
        withDestroy
      />
    ),
    grow: '1',
    ignoreRowClick: true,
    allowOverflow: false,
    right: true,
    center: true
  }
]);

export default permissionAdminDaysColumns;
